import * as React from 'react';
// import * as d3 from "d3";

import Appbar from './components/Appbar/Appbar';
import Stack from './components/Stack/Stack';
import IncomeManagement from './components/IncomeManagement/IncomeManagement';
import ExpenseManagement from './components/ExpenseManagement/ExpenseManagement';
import AssetManagement from './components/AssetManagement/AssetManagement';

import type { Income } from './types/Income';
import type { Expense } from './types/Expense';
import type { Entity } from './types/Entity';

// import logo from './logo.svg';
import './App.css';


function App(): React.JSX.Element {

    const [incomes, setIncomes] = React.useState<Income[]>([]);
    const [expenses, setExpenses] = React.useState<Expense[]>([]);
    const [assets, setAssets] = React.useState<Entity[]>([]);
    const [debts, setDebts] = React.useState<Entity[]>([]);

    // Prevent users from accendently closing the tab
    React.useEffect(() => {
        window.addEventListener("beforeunload", (event) => {
            event.preventDefault();
        });
    }, []);

    // const data = [1, 1, 2, 3, 5, 8, 13, 21];
    // const pie = d3.pie();
    // const arcs = pie(data);    

    const yearly = (elements: Income[] | Expense[]): number => {
        // Calculates the income for the current year
        let gross = 0;
        let year = (new Date()).getFullYear();
        let startDate = new Date(year, 0, 1);
        let endDate = new Date(year, 11, 31);
        elements.forEach((element) => {
            console.log(element);
            gross += element.payout(startDate, endDate);
        });
        return gross;
    }

    const monthly = (elements: Income[] | Expense[]): number => {
        // Calculates the income for the current month
        let gross = 0;
        let now = new Date();
        let startDate = new Date(now.getFullYear(), now.getMonth(), 1);
        // gets last day of the current month
        let endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        elements.forEach((element) => {
            gross += element.payout(startDate, endDate);
        });
        return gross;
    }

    const toDate = (elements: Income[] | Expense[]): number => {
        // Calculate the income to the current date
        let gross = 0;
        let now = new Date();
        let startDate = new Date(now.getFullYear(), 0, 1);
        elements.forEach((element) => {
            gross += element.payout(startDate, now);
        });
        return gross;
    }

    return (
        <div className="App">
            <Appbar></Appbar>
            <Stack direction="row">
                <Stack direction="column">
                    <IncomeManagement incomes={incomes} setIncomes={setIncomes}></IncomeManagement>
                    <p>Expected income for {(new Date()).getFullYear()}: ${yearly(incomes).toFixed(2)}</p>
                    <p>Income for the current year so far: ${toDate(incomes).toFixed(2)}</p>
                    <p>Expected income for the current month: ${monthly(incomes).toFixed(2)}</p>
                </Stack>

                <Stack direction="column">
                    <ExpenseManagement expenses={expenses} setExpenses={setExpenses}></ExpenseManagement>
                    <p>Expected expenses for {(new Date()).getFullYear()}: ${yearly(expenses).toFixed(2)}</p>
                    <p>Expenses for the current year so far: ${toDate(expenses).toFixed(2)}</p>
                    <p>Expected expenses for the current month: ${monthly(expenses).toFixed(2)}</p>
                </Stack>

                <Stack direction="column">
                    <AssetManagement assets={assets} setAssets={setAssets}></AssetManagement>
                </Stack>

                <Stack direction="column">
                    <AssetManagement assets={debts} setAssets={setDebts}></AssetManagement>
                </Stack>
            </Stack>
            <p>Savings: ${(yearly(incomes) - yearly(expenses)).toFixed(2)}</p>
            {/* <svg>
                <g>
                    {}
                </g>
            </svg> */}
        </div>
    );
}


export default App;
